module.exports = __webpack_public_path__ + "img/1.121235d5.png";